module.exports = __webpack_public_path__ + "9aef1296fce61c77dffa38cf23e9a700.png";